<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import moment from 'moment'
import {
  eventListMethod,
  authComputed,
  categoryListMethod,
  categoryComputed,
  siteListMethod,
  userListMethod,
  departmentListMethod,
  departmentComputed,
  collegeListMethod,
  collegeComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Event',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      name: '',
      features: [],
      topics: [],
      overview: '',
      description: '',
      type: null,
      options: [
        { value: null, text: 'Please select an option' },
        { value: 'ONLINE', text: 'Online Event' },
        { value: 'OFFLINE', text: 'Offline Event' },
      ],
      date: '',
      time: '',
      eventError: null,
      category: null,
      subcategory: null,
      eventDataStatus: false,
      isEventError: false,
      isLoading: false,
      editorData: '',
      categoryName: '',
      image: '',
      show: false,
      siteconfiglist: [],
      platformId: 0,
      validTypeError: false,
      validSizeError: false,
      nameCharsLeft: '',
      overviewCharsLeft: '',
      descriptionCharsLeft: '',
      collegelist: [],
      classlist: [],
      collegeId: null,
      collegeClass: [],
      departmentId: [],
      departmentlist: [],
      datetime: '',
    }
  },
  computed: {
    ...categoryComputed,
    ...authComputed,
    ...departmentComputed,
    ...collegeComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    if (this.role === 'admin') {
      this.getListOfPlatform()
      this.getColleges()
    } else {
      this.platformId = this.profileData.platform_id
    }
    const filter = {
      page: this.$route.query.page ? this.$route.query.page : 1,
      limit: 100,
      sort: 'date',
      order: '1',
    }
    this.fetchCategoryList({ filter })
    if (this.role === 'administrator') {
      this.getColleges()
    }
    if (this.role === 'college') {
      this.collegeId = this.profileData.college_id
      this.getDepartments()
    }
    if (this.role === 'hod') {
      this.collegeId = this.profileData.college_id
      this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
    if (this.role === 'teacher') {
      this.collegeId = this.profileData.college_id
      this.collegeClass = this.profileData.collegeClass
      this.departmentId.push(this.profileData.department)
    }
  },
  methods: {
    ...eventListMethod,
    ...categoryListMethod,
    ...siteListMethod,
    ...userListMethod,
    ...departmentListMethod,
    ...collegeListMethod,
    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          // listitems.push({value:'All', text: 'All'})
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },
    getColleges() {
      this.collegeId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select College',
            disabled: true,
          })
          college.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },
    addEventData() {
      if (
        localStorage.getItem('width') === '500' &&
        localStorage.getItem('height') === '500'
      ) {
        this.validSizeError = false
      } else {
        this.validSizeError = true
      }
      if (!this.validTypeError && !this.validSizeError) {
        if (this.date !== '' && this.time !== '') {
          this.datetime = moment(
            `${this.date} ${this.time}`,
            'YYYY-MM-DD HH:mm:ss'
          ).format()
        }
        this.isLoading = true
        let eventData = {
          name: this.name,
          category_id: this.category,
          subcategory_id: this.subcategory,
          image: this.image,
          description: this.description,
          overview: this.overview,
          features: this.features,
          topics: this.topics,
          type: this.type,
          category: this.categoryName,
          platform_id: this.platformId,
          date: this.datetime,
          time: this.datetime,
          collegeClass: this.collegeClass,
          department: this.departmentId,
          college_id: this.collegeId,
        }
        this.addEvent({ eventData })
          .then((data) => {
            this.isLoading = false
            this.$router.push({ name: 'event.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.eventError = getError.message
            this.isEventError = true
            window.scrollTo(0, 0)
          })
      }
    },

    // trigger when select category
    selectCategory() {
      this.show = true
      this.categoryName = this.getCategoryName()
      this.fetchSubCategoryList({ category: this.category }).then((sub) => {
        this.show = false
      })
    },

    // it will return catgeory name
    getCategoryName() {
      var cate = this.categoryList.filter((item) => {
        return item._id === this.category
      })
      return cate[0].name
    },

    // trigger when select image in input
    uploadImage: function () {
      var file = document.querySelector('input[type=file]').files[0]
      let mimeType = document.querySelector('input[type=file]').files[0].type
      if (
        mimeType === 'image/png' ||
        mimeType === 'image/jpeg' ||
        mimeType === 'image/jpg'
      ) {
        this.validTypeError = false
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('width', img.width)
            localStorage.setItem('height', img.height)
          }
          img.src = evt.target.result
          this.image = reader.result
        }
      } else {
        this.validTypeError = true
      }
    },
    // filter tag
    filterTag(tags) {
      var finalTags = []
      tags.forEach((element) => {
        finalTags.push(element.text)
      })
      return finalTags
    },
    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate() + 2)
      return minDate
    },
    getCount(value) {
      if (value === 'overview') {
        this.overviewCharsLeft = 400 - this.overview.length
        if (this.overview.length >= 400) {
          this.overviewCharsLeft = 0
        }
      } else if (value === 'description') {
        this.descriptionCharsLeft = 400 - this.description.length
        if (this.description.length >= 400) {
          this.descriptionCharsLeft = 0
        }
      } else if (value === 'name') {
        this.nameCharsLeft = 100 - this.name.length
        if (this.name.length >= 100) {
          this.nameCharsLeft = 0
        }
      }
    },
    tagValidator(tag) {
      if (tag.length > 30) {
      } else {
        return tag
      }
    },
    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    getClasses() {
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isEventError"
              variant="danger"
              v-html="eventError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="addEventData"
            >
              <b-form-group
                label="Name*(Max:100 characters)"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="name"
                  type="text"
                  parsley-trigger="change"
                  placeholder="Enter Event Name"
                  :maxlength="100"
                  @keyup="getCount('name')"
                  @keypress="restrictChars($event)"
                ></b-form-input>
                <p v-if="nameCharsLeft !== ''"
                  >Characters left : {{ nameCharsLeft }}</p
                >
              </b-form-group>
              <b-form-group label="Category*" label-for="input-2">
                <b-form-select
                  v-model="category"
                  parsley-trigger="change"
                  @change="selectCategory"
                >
                  <b-select-option :value="null" disabled
                    >Select Category</b-select-option
                  >
                  <b-select-option
                    v-for="cate in categoryList"
                    :key="`cate${cate._id}`"
                    :value="cate._id"
                    >{{ cate.name }}</b-select-option
                  >
                </b-form-select>
              </b-form-group>
              <b-form-group label="Sub category" label-for="input-2">
                <b-form-select v-model="subcategory" parsley-trigger="change">
                  <b-select-option :value="null" disabled
                    >Select SubCategory</b-select-option
                  >
                  <b-select-option
                    v-for="cate in subCategoryList"
                    :key="`cate${cate._id}`"
                    :value="cate._id"
                    >{{ cate.name }}</b-select-option
                  >
                </b-form-select>
              </b-form-group>
              <b-form-group
                label="Event Overview*(Max:400 characters)"
                label-for="input-2"
              >
                <b-form-textarea
                  id="textarea"
                  v-model="overview"
                  placeholder="Enter Event Overview"
                  rows="3"
                  max-rows="6"
                  :maxlength="400"
                  @keyup="getCount('overview')"
                ></b-form-textarea>
                <p v-if="overviewCharsLeft !== ''"
                  >Characters left : {{ overviewCharsLeft }}</p
                >
              </b-form-group>
              <b-form-group
                label="Event Description*(Max:400 characters)"
                label-for="input-2"
              >
                <b-form-textarea
                  id="textarea"
                  v-model="description"
                  placeholder="Enter Event Description"
                  rows="5"
                  max-rows="6"
                  :maxlength="400"
                  @keyup="getCount('description')"
                ></b-form-textarea>
                <p v-if="descriptionCharsLeft !== ''"
                  >Characters left : {{ descriptionCharsLeft }}</p
                >
              </b-form-group>
              <b-form-group
                label="Event Image*(Size: 500*500)"
                label-for="input-2"
              >
                <b-form-file
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  accept="image/jpeg, image/png, image/jpg"
                  @change="uploadImage"
                ></b-form-file>
                <p v-if="validTypeError" class="showError"
                  >Not a valid file type</p
                >
                <p v-if="validSizeError" class="showError"
                  >Image Dimensions should be 500*500</p
                >
              </b-form-group>
              <b-form-group
                label="Event Features* (Max length of 30 characters for each feature)"
                label-for="input-2"
              >
                <b-form-tags
                  v-model="features"
                  tag-pills
                  class="mb-2"
                  placeholder="Enter Features and Press Enter..."
                  :tag-validator="tagValidator"
                ></b-form-tags>
              </b-form-group>
              <b-form-group
                label="Event Topics* (Max length of 30 characters for each topic)"
                label-for="input-2"
              >
                <b-form-tags
                  v-model="topics"
                  tag-pills
                  class="mb-2"
                  placeholder="Enter Topics and Press Enter..."
                  :tag-validator="tagValidator"
                ></b-form-tags>
              </b-form-group>
              <b-form-group label="Event Date*" label-for="input-2">
                <b-form-datepicker
                  id="example-datepicker"
                  v-model="date"
                  :min="getMinDate()"
                  class="col-md-5"
                ></b-form-datepicker>
              </b-form-group>
              <b-form-group label="Event Time*" label-for="input-2">
                <b-form-timepicker
                  v-model="time"
                  locale="en"
                  class="col-md-5"
                ></b-form-timepicker>
              </b-form-group>
              <b-form-group label="Event Type*" label-for="input-2">
                <b-form-select
                  v-model="type"
                  :options="options"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="role === 'admin'"
                label="Select Platform*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="platformId"
                  :options="siteconfiglist"
                  @change="getColleges"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="role === 'administrator' || role === 'admin'"
                label="Select College*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeId"
                  :options="collegelist"
                  @change="getDepartments"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="role !== 'hod' && role !== 'teacher'"
                label="Select Department*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="departmentId"
                  :options="departmentlist"
                  multiple
                  @change="getClasses"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                v-if="role !== 'teacher'"
                label="Select Class*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeClass"
                  :options="classlist"
                  multiple
                ></b-form-select>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/event-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.showError {
  color: red;
}
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}
</style>
